var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoadingOverlay',{attrs:{"data-test-id":_vm.$testId('loadingOverlay'),"visible":_vm.showLoadingOverlay,"zIndex":1001}}),(!_vm.isSkipping)?_c('UseCaseOnboarding'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }